<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
    :class="[color === 'light' ? 'bg-white' : 'bg-emerald-900 text-white']"
  >
  
    <DeleteModal
      :show="delteModalShow"
      :deleteReuqest="deleteReuqest"
      :modalClose="toggleCloseModal"
    />

    <CardFilter   
      v-if="filters != null && filters.length > 0" 
      :filterData="filters" 
      :path="path" 
      :page="currentPage" 
      :filterVals="getFilterKeyObj(filters)"
    />
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="flex justify-between	flex-wrap items-center">
       
        <div class="relative px-4">
          <h3
            class="font-semibold text-lg"
            :class="[color === 'light' ? 'text-blueGray-700' : 'text-white']"
          >
            {{ pageTitle  }}
          </h3>
        </div>

        <div class="py-2 flex">
          
          <div class="relative flex w-full flex-wrap items-stretch mb-3 mr-3">
            <span 
              class="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-2 py-2">
              <i class="fas fa-search text-blueGray-600"></i>
            </span>
            <input 
              :value=searchVal
              v-on:keyup.enter="inputSearch"
              type="text" 
              placeholder="Поиск" 
              class="px-2 py-1 placeholder-blueGray text-blueGray-600 relative bg-white bg-white rounded text-sm border border-blueGray outline-none focus:outline-none focus:shadow-outline w-full pl-10" 
              >
          </div>

          <div class="relative w-full mb-3">
            <select
              @change="selectPage"
              class='border-blueGray border placeholder-blueGray text-blueGray-600 bg-white rounded'>
              <option 
                v-for="(item, index) in navItems" :key="index+1"
                :value="index+1"
                :selected="currentPage == index + 1"
              >{{ index+1 }}</option>
            </select>
          </div>
        </div>

          <div class="relative inline-flex align-middle">
            <router-link
              v-if="(addLink || candAdd.indexOf(user.role.key) != -1)"
              :to="{ path: $route.path + '-add' }"  
              v-slot="{ href, navigate }"
            >
              <button 
                :href="href"
                @click="navigate"
                class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
                    <i 
                      style='margin-right: 15px'
                      class="fas fa-plus"></i> Добавить
              </button>
            </router-link>
            <button 
              ref="btnDropdownRef" 
              v-on:click="toggleDropdown()"
              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
              <i 
                style='margin-right: 15px'
                class="fas fa-file-excel"></i> Скачать excel
            </button>
            <div 
              style="max-height: 300px; overflow-y: scroll;"
              v-bind:class="{hidden: !dropdownPopoverShow,block: dropdownPopoverShow,}"
              ref="popoverDropdownRef" class="bg-emerald-500 text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mt-1 min-w-48" >
            </div>
          </div>

      </div>
    </div>

    <div class="block w-full overflow-x-auto">
      <!-- Projects table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
          <tr>
            <th
              style='width: 5%;'
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 font-semibold text-left"
              :class="[
                color === 'light'
                  ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                  : 'bg-emerald-800 text-emerald-300 border-emerald-700',
              ]"
            >
              #
            </th>
            <th
              v-for="( val,  index ) in bodyKeys" :key="index"
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 font-semibold text-left"
              :class="[
                getPageWidth(val.name),
                color === 'light'
                  ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                  : 'bg-emerald-800 text-emerald-300 border-emerald-700',
              ]"
            >
              {{ val.title }}
            </th>
              <th
                style='width: 5%;'
                class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 font-semibold text-left"
                :class="[
                  color === 'light'
                    ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-emerald-800 text-emerald-300 border-emerald-700',
                ]"
              >
                Действие
              </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in bodyData" :key="index">
            <td
              style='width: 5%;'
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs p-4"
            >
              {{ (index + 1) + (currentPage - 1) * post_per_page   }}
            </td>
            <td
              v-for="(key, in_index) in bodyKeys" :key="in_index"
              :class="[
                getPageWidth(in_index),
                'border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs p-4'
              ]"
            > 
              <div v-if="in_index == field_key">
                <span class='font-bold'>
                  <router-link
                    :to="{ path: path + data.id }"  
                    v-slot="{ href, navigate, isActive }"
                  >
                    <a
                      :href="href"
                      @click="navigate"
                      class="text-xs uppercase py-3 font-bold block"
                      :class="[
                        isActive
                          ? 'text-white-500 hover:text-white-600'
                          : 'text-blueGray-700 hover:text-blueGray-500',
                      ]"
                    >
                      {{ getVal(key.name, key.type, data) }}
                    </a>
                  </router-link>
                </span>
              </div>              
              <div v-else-if="bodyType[key.name] == 'bold'">
                <span class='font-bold'>
                  {{ getVal(key.name, key.type, data) }}
                </span>
              </div>
              <div v-else-if="key.type == 'image'">
                <img 
                  v-if="getVal(key.name, key.type, data) != '-'"
                  style='max-height: 50px; max-width: 50px; width: auto; height: auto;'
                  :src="`${getVal(key.name, key.type, data)}`" >
              </div>
              <div v-else-if="key.type == 'file'">
                <a 
                  :href="getVal(key.name, key.type, data)"><b>{{ getFIleName(getVal(key.name, key.type, data)) }}</b></a>
              </div>
              <div v-else-if="key.type == 'bool'">
                  <div v-if="getVal(key.name, key.type, data) == true" >Да</div>
                  <div v-else>Нет</div>
              </div>
              <div v-else>
                {{ getVal(key.name, key.type, data) }}
              </div>
            </td>
            <td
              style='width: 5%;'
              class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right"
            >
              <component 
                :elData="data"
                :is="dropDownComponent"
                :openDeleteModal="openDeleteModal"
                :path="path"
                :index="index"
                :updateRowData="updateRowData"
                ></component>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import svgLoader from "@/assets/img/preloader.svg";

import axios from 'axios';
import { createPopper } from "@popperjs/core";
import { HEADERS_TOKEN, HEADERS_TOKEN_JSON } from '@/const/uri';
import { mapState } from 'vuex'
import { BASE_HOST } from '@/const/uri.dev';
import CardFilter from '@/components/Cards/CardFilters.vue';
import DeleteModal from '@/components/Modals/DeleteModal.vue';
import { defineAsyncComponent } from "vue";

export default {
  data() {
    return {
      BASE_HOST: BASE_HOST,
      svgLoader, 
      dropdownPopoverShow: false,
      columns: {}, 
      usersData: [], 
      bodyData: [],
      bodyKeys: [],
      filters: null,
      bodyType: {
        iin: 'bold',
      },
      deleteData: null,
      delteModalShow: false,
      excludeIds: [], 
      navItems: [],
      post_per_page: 15,
      searchVal: '', 
      currentPage: null, 
      dateList: [], 
      activeUserId: 0,
      activeCheckId: 0,
      isDataLoad: false,
    };
  },
  computed: {
    ...mapState(['user']),
    dropDownComponent() {
      return defineAsyncComponent(() => {
        if(this.$props.dropDownComponentString == null) {
          return import(`@/components/Dropdowns/TableDropdownUser.vue`);
        }
        return import(`@/components/Cards/Dropdown/${this.$props.dropDownComponentString}.vue`);
      });
    }, 
  },
  components: {
    DeleteModal,
    CardFilter,
  },
  watch:{
      $route(to, from){
        if(to.name != from.name) {
          this.currentPage = 1; 
        }
        this.searchVal = ''; 
        this.loadData();
      },
  }, 
  beforeUpdate() {
    if(!this.isDataLoad) {
      this.loadPage();
      this.getCurrentPage();
      this.loadData();
      this.isDataLoad = true;
    }
  }, 
  mounted() {
    this.loadPage();
    this.getCurrentPage();
    this.loadData(); 
    this.isDataLoad = true;
  }, 
  methods: {
    updateRowData(ind, key, val) {
      this.bodyData[ind][key] = val
    },
    deleteRow(elData) {
      this.bodyData = this.bodyData.filter((el) => el.id != elData.id);
    }, 
    async deleteReuqest() {
      await axios({
        method: "DELETE", 
        url: this.$props.pageUrl + this.deleteData.id + '/',
        headers: HEADERS_TOKEN_JSON(),
      }).then(() => {
        this.deleteRow(this.deleteData);
        this.toggleCloseModal();
      }).catch((e) => {
        console.log(e);
      }); 
    },
    openDeleteModal(data) {
      this.deleteData = data;
      this.delteModalShow = true;
    }, 
    toggleCloseModal() {
      this.delteModalShow = !this.delteModalShow;
    },
    getCurrentPage() {
      const page = parseInt(this.$route.query.page) || 1;
      if(isNaN(page)) {
        this.currentPage = 1;
        return 1;
      }
      this.currentPage = page;
      return page;
    },
    getPageWidth(key) {
      let val = this.filedWidth[key];
      if(!val) return '';
      return 'inl-' + val;
    },  
    selectPage(e){
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: e.target.value,
        }
      });
    }, 
    inputSearch(e) {
      this.searchVal = e.target.value;
      this.loadData(); 
    }, 
    getSearchParameters() {
      var prmstr = window.location.search.substr(1);
      return prmstr != null && prmstr != "" ? this.transformToAssocArray(prmstr) : {};
    },
    transformToAssocArray(prmstr) {
      var params = {};
      var prmarr = prmstr.split("&");
      for (var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        if(tmparr[0] == 'page') continue;
        params[tmparr[0]] = tmparr[1];
      }
      return params;
    },
    toggleDropdown: function () {
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
    loadPage() {
      if(this.$route.params.page) 
        this.currentPage = this.$route.params.page;
    }, 
    changePage(e) {
      this.currentPage = e.target.dataset.page;
    },
    toggleModal() {
      this.showModal = !this.showModal; 
    }, 
    filterUsers() {
      this.usersData = this.usersData.filter( (x) => !this.excludeIds.includes(x.check_id) );
    }, 
    openModal(user_id, check_id) {
      const self = this;
      function wrapper() {
        self.activeUserId = user_id;
        self.activeCheckId = check_id;
        self.showModal = true;  
      }
      return wrapper; 
    },  
    getFilterKeyObj(filters) {
      let obj = {};
      filters.forEach(element => {
        obj[element.key] = [];
      });
      return obj;
    },
    getFIleName(val) {
      const parts = val.split("/");
      return parts[parts.length - 1];
    },
    getVal(key, type, data,) {
      if(!data[key]) return '-'
      if(type == 'str') return data[key];
      if(type == 'choice') return data[key].val;
      return data[key];
    },
    updateNavItems(count) {
      const countData = count;
      const pages = Math.ceil(countData / this.post_per_page);
      this.navItems = [];
      for (let index = 0; index < pages; index++) {
        this.navItems.push(index + 1);
      }
      if (pages == 0) {
        this.navItems.push(1);
      }
    }, 
    async loadData() {
      const self = this;
      this.getCurrentPage();
      await axios({
        method: "GET",
        params: {
          p: this.currentPage,
          page_size: this.post_per_page,
          ...this.getSearchParameters(),
        },
        url: self.pageUrl,
        headers: HEADERS_TOKEN(),
      }).then(function(e) {
        const data = e.data.data;
        self.bodyData = data.results.page;
        self.bodyKeys = data.results.keys;
        self.updateNavItems(data.count);
        self.filters = data.results.filters;
      }).catch(function(e) {
        console.log(e);
      }); 
    }, 
  }, 
  props: {
    filedWidth: {
      default: {},
    },
    path: {
      default: '/admin/user/', 
    },  
    pageTitle: {
      default: "",
    }, 
    field_key: {
      default: "",
    },
    pageUrl: {
      default: "",
    }, 
    addLink: {
      default: true,
    },
    candAdd: {
      default: [0, ],
    },
    dropDownComponentString: {
      default: null,
    },
    color: {
      default: "light",
      validator: function (value) {
        return ["light", "dark"].indexOf(value) !== -1;
      },
    },
  },
};
</script>
